// @flow

export default {
  // No trailing slash
  MARKETING_ROOT: process.env.GATSBY_MARKETING_ROOT,
  PORTAL_ROOT: process.env.GATSBY_PORTAL_ROOT,
};
